import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import { MetricDependencyType, TypeMetricAssignedTo, useGetUserQuery, useListMetricsQuery, MetricReportingPeriodType } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _ref = useNuxtApp(),
      $i18n = _ref.$i18n;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var headers = [{
      value: 'id',
      cellClass: 'font-weight-bold',
      sortable: true
    }, {
      value: 'name',
      cellClass: 'font-weight-bold',
      sortable: true
    }, {
      value: 'unitName'
    }, {
      value: 'assignedTo'
    }, {
      value: 'valueType'
    }, {
      value: 'valueOptions'
    }, {
      value: 'sections',
      cellClass: 'overflow-auto'
    }, {
      value: 'externalData',
      cellClass: 'max-w-[200px]'
    }, {
      value: 'isComputed'
    }, {
      value: 'defaultReportingPeriodType'
    }, {
      value: 'allowQuarterlyInput'
    }, {
      text: 'Created by',
      value: 'isAdminKpi'
    }, {
      value: 'category'
    },
    // {
    //   value: 'taxonomy',
    //   cellClass: 'overflow-auto', # this is deprecated and we should use taxonomy from sections
    // },
    {
      text: $i18n.t('actions'),
      value: 'actions'
    }].map(function (col) {
      return _objectSpread(_objectSpread({}, col), {}, {
        sortable: col.sortable || false
      });
    });
    var route = useRoute();
    var routeSearchValue = computed(function () {
      return Array.isArray(route.query.search) ? route.query.search[0] || '' : route.query.search || '';
    });
    var options = ref({
      page: 1,
      itemsPerPage: 15,
      sortBy: ['id'],
      sortDesc: [true]
    });
    var taxonomiesFilters = ref([]);
    var assignedToFilters = ref([]);
    var sectionsFilters = ref([]);
    var isComputedFilter = ref([]);
    var allowQuarterlyInputFilter = ref([]);
    var categoryFilters = ref([]);
    var filterNoCategory = ref(false);
    var defaultReportingPeriodTypeFilter = ref([]);
    var isAdminKpiFilter = ref([]);
    var expanded = ref([]);
    var handleNoCategoryChange = function handleNoCategoryChange(value) {
      if (value) {
        categoryFilters.value = [];
      }
    };
    var expandedMetricId = computed(function () {
      var firstExpanded = expanded.value[0];
      if (!firstExpanded) return null;
      if (typeof firstExpanded === 'number') return firstExpanded;
      if (_typeof(firstExpanded) === 'object' && firstExpanded.id !== undefined) {
        return Number(firstExpanded.id);
      }
      return null;
    });
    var buildRelationshipQuery = function buildRelationshipQuery(metricId, dependencyType, dependencyDirection) {
      return _objectSpread(_objectSpread({}, dependencyDirection === 'children' ? {
        parentIds: [metricId]
      } : {
        childIds: [metricId]
      }), {}, {
        dependencyTypes: [dependencyType],
        directOnly: true
      });
    };
    var computationalChildrenVariables = computed(function () {
      return {
        input: buildRelationshipQuery(expandedMetricId.value || -1, MetricDependencyType.Computational, 'children'),
        offset: 0,
        limit: 1
      };
    });
    var conditionalChildrenVariables = computed(function () {
      return {
        input: buildRelationshipQuery(expandedMetricId.value || -1, MetricDependencyType.Conditional, 'children'),
        offset: 0,
        limit: 1
      };
    });
    var computationalParentsVariables = computed(function () {
      return {
        input: buildRelationshipQuery(expandedMetricId.value || -1, MetricDependencyType.Computational, 'parents'),
        offset: 0,
        limit: 1
      };
    });
    var conditionalParentsVariables = computed(function () {
      return {
        input: buildRelationshipQuery(expandedMetricId.value || -1, MetricDependencyType.Conditional, 'parents'),
        offset: 0,
        limit: 1
      };
    });
    var variables = computed(function () {
      var _isComputedFilter$val, _isAdminKpiFilter$val, _allowQuarterlyInputF;
      var search = Array.isArray(route.query.search) ? route.query.search[0] || '' : route.query.search || '';
      var input = {
        text: search,
        taxonomies: taxonomiesFilters.value,
        assignedTos: assignedToFilters.value,
        sections: sectionsFilters.value,
        isComputed: [2, 0].includes((_isComputedFilter$val = isComputedFilter.value) === null || _isComputedFilter$val === void 0 ? void 0 : _isComputedFilter$val.length) ? null : isComputedFilter.value[0],
        isAdminKpi: [2, 0].includes((_isAdminKpiFilter$val = isAdminKpiFilter.value) === null || _isAdminKpiFilter$val === void 0 ? void 0 : _isAdminKpiFilter$val.length) ? null : isAdminKpiFilter.value[0],
        defaultReportingPeriodType: defaultReportingPeriodTypeFilter.value,
        allowQuarterlyInput: [2, 0].includes((_allowQuarterlyInputF = allowQuarterlyInputFilter.value) === null || _allowQuarterlyInputF === void 0 ? void 0 : _allowQuarterlyInputF.length) ? null : allowQuarterlyInputFilter.value[0],
        categoryIds: filterNoCategory.value ? [null] : categoryFilters.value,
        sort: options.value.sortBy.map(function (item, index) {
          return {
            field: item,
            sortDesc: options.value.sortDesc[index]
          };
        })
      };
      return {
        input: input,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListMetricsQuery = useListMetricsQuery(variables),
      result = _useListMetricsQuery.result,
      loading = _useListMetricsQuery.loading,
      refetch = _useListMetricsQuery.refetch;
    var _useListMetricsQuery2 = useListMetricsQuery(computationalChildrenVariables, function () {
        return {
          enabled: expandedMetricId.value !== null,
          fetchPolicy: 'network-only'
        };
      }),
      computationalChildrenResult = _useListMetricsQuery2.result;
    var _useListMetricsQuery3 = useListMetricsQuery(conditionalChildrenVariables, function () {
        return {
          enabled: expandedMetricId.value !== null,
          fetchPolicy: 'network-only'
        };
      }),
      conditionalChildrenResult = _useListMetricsQuery3.result;
    var _useListMetricsQuery4 = useListMetricsQuery(computationalParentsVariables, function () {
        return {
          enabled: expandedMetricId.value !== null,
          fetchPolicy: 'network-only'
        };
      }),
      computationalParentsResult = _useListMetricsQuery4.result;
    var _useListMetricsQuery5 = useListMetricsQuery(conditionalParentsVariables, function () {
        return {
          enabled: expandedMetricId.value !== null,
          fetchPolicy: 'network-only'
        };
      }),
      conditionalParentsResult = _useListMetricsQuery5.result;
    var items = computed(function () {
      var _result$value$listMet, _result$value;
      return (_result$value$listMet = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listMetrics) !== null && _result$value$listMet !== void 0 ? _result$value$listMet : [];
    });
    var itemCount = computed(function () {
      var _result$value$countMe, _result$value2;
      return (_result$value$countMe = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countMetrics) !== null && _result$value$countMe !== void 0 ? _result$value$countMe : 0;
    });
    var hasComputationalChildren = computed(function () {
      var _computationalChildre;
      return (((_computationalChildre = computationalChildrenResult.value) === null || _computationalChildre === void 0 ? void 0 : _computationalChildre.countMetrics) || 0) > 0;
    });
    var hasConditionalChildren = computed(function () {
      var _conditionalChildrenR;
      return (((_conditionalChildrenR = conditionalChildrenResult.value) === null || _conditionalChildrenR === void 0 ? void 0 : _conditionalChildrenR.countMetrics) || 0) > 0;
    });
    var hasComputationalParents = computed(function () {
      var _computationalParents;
      return (((_computationalParents = computationalParentsResult.value) === null || _computationalParents === void 0 ? void 0 : _computationalParents.countMetrics) || 0) > 0;
    });
    var hasConditionalParents = computed(function () {
      var _conditionalParentsRe;
      return (((_conditionalParentsRe = conditionalParentsResult.value) === null || _conditionalParentsRe === void 0 ? void 0 : _conditionalParentsRe.countMetrics) || 0) > 0;
    });
    var hasAnyRelationships = computed(function () {
      return hasComputationalChildren.value || hasConditionalChildren.value || hasComputationalParents.value || hasConditionalParents.value;
    });
    var assignedToFiltersLength = computed(function () {
      return assignedToFilters.value && assignedToFilters.value.length || 0;
    });
    var getCategoryLabel = function getCategoryLabel(item) {
      return item && item.category ? item.category.label : '';
    };
    var getValueOptionKey = function getValueOptionKey(option, idx) {
      if (option === null || option === undefined) return "option-".concat(idx);
      if (typeof option === 'string' || typeof option === 'number') return "".concat(option);
      if (_typeof(option) === 'object') {
        if ('id' in option && option.id !== undefined) return "option-id-".concat(option.id);
        if ('value' in option && option.value !== undefined) return "option-value-".concat(option.value);
        if ('text' in option && option.text !== undefined) return "option-text-".concat(option.text, "-").concat(idx);
      }
      return "option-".concat(idx);
    };
    var selected = ref([]);
    var newItem = ref({});
    var deleteDialog = ref(false);
    var deleteItem = function deleteItem() {
      // TODO
    };
    var closeDelete = function closeDelete() {
      deleteDialog.value = false;
    };
    var editDialog = ref({});
    var setEditDialog = function setEditDialog(id, v) {
      editDialog.value = _defineProperty({}, id, v);
    };
    var createDialog = ref(false);
    var handleUpsert = function handleUpsert() {
      refetch();
      createDialog.value = false;
      editDialog.value = {};
    };
    return {
      __sfc: true,
      $i18n: $i18n,
      userResult: userResult,
      user: user,
      headers: headers,
      route: route,
      routeSearchValue: routeSearchValue,
      options: options,
      taxonomiesFilters: taxonomiesFilters,
      assignedToFilters: assignedToFilters,
      sectionsFilters: sectionsFilters,
      isComputedFilter: isComputedFilter,
      allowQuarterlyInputFilter: allowQuarterlyInputFilter,
      categoryFilters: categoryFilters,
      filterNoCategory: filterNoCategory,
      defaultReportingPeriodTypeFilter: defaultReportingPeriodTypeFilter,
      isAdminKpiFilter: isAdminKpiFilter,
      expanded: expanded,
      handleNoCategoryChange: handleNoCategoryChange,
      expandedMetricId: expandedMetricId,
      buildRelationshipQuery: buildRelationshipQuery,
      computationalChildrenVariables: computationalChildrenVariables,
      conditionalChildrenVariables: conditionalChildrenVariables,
      computationalParentsVariables: computationalParentsVariables,
      conditionalParentsVariables: conditionalParentsVariables,
      variables: variables,
      result: result,
      loading: loading,
      refetch: refetch,
      computationalChildrenResult: computationalChildrenResult,
      conditionalChildrenResult: conditionalChildrenResult,
      computationalParentsResult: computationalParentsResult,
      conditionalParentsResult: conditionalParentsResult,
      items: items,
      itemCount: itemCount,
      hasComputationalChildren: hasComputationalChildren,
      hasConditionalChildren: hasConditionalChildren,
      hasComputationalParents: hasComputationalParents,
      hasConditionalParents: hasConditionalParents,
      hasAnyRelationships: hasAnyRelationships,
      assignedToFiltersLength: assignedToFiltersLength,
      getCategoryLabel: getCategoryLabel,
      getValueOptionKey: getValueOptionKey,
      selected: selected,
      newItem: newItem,
      deleteDialog: deleteDialog,
      deleteItem: deleteItem,
      closeDelete: closeDelete,
      editDialog: editDialog,
      setEditDialog: setEditDialog,
      createDialog: createDialog,
      handleUpsert: handleUpsert,
      MetricDependencyType: MetricDependencyType,
      TypeMetricAssignedTo: TypeMetricAssignedTo,
      MetricReportingPeriodType: MetricReportingPeriodType
    };
  }
});